module.exports = __webpack_public_path__ + "img/banner1.8b29fa1e.png";